<template>
  <div class="ArtistProfilePage container-bootstrap">
    <ArtistPaidProfile v-if="artist.paid_plan" />
    <ArtistFreeProfile v-if="!artist.paid_plan" />
    <ArtistPortfolio v-if="showPortfolio" />
  </div>
</template>

<script setup>
import ArtistPortfolio from "./ArtistPortfolio.vue"
import ArtistPaidProfile from "./ArtistPaidProfile.vue"
import ArtistFreeProfile from "./ArtistFreeProfile.vue"

import { provide, ref } from "vue"

const props = defineProps({
  artist: Object,
  sortOptions: Object,
  showPortfolio: Boolean,
  isAdmin: Boolean,
})
const {
  sortOptions,
  isAdmin,
  artist: { artist },
} = props

delete sortOptions["prints"]

const sort = ref("best-match")
const page = ref(1)

const fetchActiveTab = () => {
  const tabName = window.location.pathname.split(`/${artist.slug}/`)[1] || "available"
  return tabName.split("/")[0]
}

const activeTab = ref(fetchActiveTab())

const studioPostSlug = ref(location.pathname.match(/studio(\/)?(\w.+)?/)?.[2])

const setStudioPostSlug = (value) => {
  window.history.pushState({ turbo: {} }, "", `/${artist.slug}/studio/${value}`)
  scrollToTop()
  studioPostSlug.value = value
}

const setTab = (tab) => {
  const newPath = tab === "available" ? `/${artist.slug}` : `/${artist.slug}/${tab}`
  window.history.pushState({ turbo: {} }, "", newPath)
  activeTab.value = tab
  studioPostSlug.value = null
  scrollToTabs()
  page.value = 1
  if (tab === "reprints" && sort.value === "originals") {
    sort.value = "best-match"
  }
}

const scrollToTop = () => {
  document.querySelector("body").scrollIntoView({
    behavior: "smooth",
  })
}

const scrollToTabs = () => {
  window.scrollTo({
    top: document.querySelector("#ArtistFilterNav").getBoundingClientRect().top + window.scrollY - 150,
    behavior: "smooth",
  })
}

provide("artist", artist)
provide("isAdmin", isAdmin)
provide("sortOptions", sortOptions)
provide("activeTab", activeTab)
provide("setTab", setTab)
provide("scrollToTop", scrollToTop)
provide("scrollToTabs", scrollToTabs)
provide("studioPostSlug", studioPostSlug)
provide("setStudioPostSlug", setStudioPostSlug)
provide("page", page)
provide("sort", sort)
</script>
